import { parseAdmissionApplicationData } from "../Accounts/accountUtils";
import { STATUS_BADGE_COLORS } from "./AdmissionStatusBadge";

export const UNLINKED_UNIVERSITY = "unlinked";

export const UNSPECIFIED_ADMISSION_STATUS = "Unspecified";

export const ADMISSION_STATUS_FILTER_OPTIONS = [
  UNSPECIFIED_ADMISSION_STATUS,
  ...Object.keys(STATUS_BADGE_COLORS),
];

export const isUnspecifiedStatus = (status) => status == null || String(status).trim() === "";

export const hasLinkedUniversity = (universityId) =>
  universityId != null && universityId !== "" && Number(universityId) !== 0;

export const resolveAdmissionListIds = (item) => {
  const app = parseAdmissionApplicationData(item?.applicationData);
  return {
    courseId: item?.course ?? app?.course ?? null,
    universityId: item?.university ?? app?.university ?? null,
    intake: item?.intake ?? app?.intake ?? null,
    state: item?.state ?? app?.state ?? null,
  };
};

export const matchesAdmissionFilters = (item, filters) => {
  const { courseId, universityId, intake } = resolveAdmissionListIds(item);
  if (filters.course && Number(courseId) !== Number(filters.course)) return false;
  if (filters.university === UNLINKED_UNIVERSITY) {
    if (hasLinkedUniversity(universityId)) return false;
  } else if (filters.university && Number(universityId) !== Number(filters.university)) {
    return false;
  }
  if (filters.intake && intake !== filters.intake) return false;
  if (filters.status === UNSPECIFIED_ADMISSION_STATUS) {
    if (!isUnspecifiedStatus(item.status)) return false;
  } else if (filters.status && item.status !== filters.status) {
    return false;
  }
  if (
    filters.accountVerificationStatus &&
    item.accountVerificationStatus !== filters.accountVerificationStatus
  ) {
    return false;
  }
  return true;
};
